<template>
    <section v-if="json" class="page-who-we-are global-fonts">
        <div class="cap">
            <template v-for="(block, index) in json.blocks" :key="`block-${index}`">
                <Header v-if="block.type=='header'" :block="block" />
                <Quote v-else-if="block.type=='quote-one' || block.type=='quote-two'" :block="block"/>
                <Slider v-else-if="block.type=='slider-one' || block.type == 'slider-two'" :block="block"/>
                <Founders v-else-if="block.type=='founders'" :block="block"/>
                <MeetTheTeam v-else-if="block.type=='meet-the-team'" :block="block"/>
                <Careers v-else-if="block.type=='careers'" :block="block"/>
            </template>
        </div>
    </section>
</template>
<script>
import axios from 'axios'
import Header from '@/components/blocks/Header'
import Quote from '@/components/blocks/Quote'
import Slider from '@/components/blocks/Slider'
import Founders from '@/components/blocks/Founders'
import MeetTheTeam from '@/components/blocks/MeetTheTeam'
import Careers from '@/components/blocks/Careers'
export default {
    name: "WhoWeAre",
    components: {
        Header,
        Quote,
        Slider,
        Founders,
        MeetTheTeam,
        Careers,
    },
    data () {
        return {
            window: window,
            json: null,
        }
    },
    created () {

    },
    mounted () {
        axios.get((`${window.config.apiroot}who-we-are${window.config.apiext}`))
            .then((res) => {
                this.json = res.data
                this.reveal()
            }).catch((err) => {
                console.error(err);
        })

    },
    methods: {
        reveal () {

        },
    }
}
</script>
